import React, { useState, useEffect } from "react";
import { InstitutionApi } from "../../../../api";
import { Loader } from "semantic-ui-react";
import { map } from "lodash";
import { ClassItem } from "./../ClassItem";
import { useTranslation } from "react-i18next";
import "./ClassList.scss"; // Importa el SCSS aquí

const institutionController = new InstitutionApi();

export function ClassList(props) {
  const { user, reload, onReload, accessToken } = props;
  const { t } = useTranslation("teachers");
  const [institution, setInstitution] = useState(null);

  //console.log(user.user.institutions[0]);
  useEffect(() => {
    (async () => {
      try {
        setInstitution(null);
        const response =
          await institutionController.getInstitutionsbyInstitution(
            accessToken,
            user.user.institutions[0],
            true,
          );
        if (response && response.institution) {
          setInstitution(response.institution);
        } else {
          setInstitution(null);
        }
      } catch (error) {
        console.error(error);
      }
    })();
  }, [user, reload, onReload, accessToken]);

  if (!institution) {
    return <Loader active inline="centered" />;
  }

  const classnumberArray = institution.classnumber || [];

  return (
    <div className="class-list">
      {classnumberArray.length === 0 ? (
        <p>{t("list.noClasses")}</p>
      ) : (
        map(classnumberArray, (item, index) => (
          <ClassItem
            key={index}
            institution={institution}
            classNameValue={item}
            posArray={index} // Aquí pasamos el índice
            onReload={onReload}
          />
        ))
      )}
    </div>
  );
}
